const getDateWorldTimeApi = async (zona = "America/Mexico_City") => {
  const response = await fetch(`https://worldtimeapi.org/api/timezone/${zona}`);
  if (!response.ok) {
    throw new Error(`Error fetching date from worldtimeapi.org: ${response.statusText}`);
  }
  const data = await response.json();
  const now = new Date(data.datetime);
  now.setHours(0, 0, 0, 0); // Set to start of the day
  console.log("Hora remota ajustada:", now);
  return now;
}

const getDateTimeAPI = async (zona = "America/Mexico_City") => {
  const url = `https://timeapi.io/api/Time/current/zone?timeZone=${zona}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Error fetching date from timeapi.io: ${response.statusText}`);
  }
  const data = await response.json();
  const now = new Date(data.dateTime);
  now.setHours(0, 0, 0, 0); // Set to start of the day
  return now;
}

const getDateServiciosAduanales = async () => {
  const response = await fetch("https://api.serviciosaduanalesrm.com/timestamp");
  if (!response.ok) {
    throw new Error(`Error fetching date from serviciosaduanalesrm.com: ${response.statusText}`);
  }
  const data = await response.json();
  const now = new Date(data.timestamp);
  now.setHours(0, 0, 0, 0); // Ajustar al inicio del día
  return now;
}

export const getDateUTC = async (zona = "America/Mexico_City") => {
  try {
    const date = await getDateServiciosAduanales();
    console.log("Fecha obtenida de serviciosaduanalesrm.com:", date);
    return date;
  } catch (error) {
    console.error("Error fetching date from serviciosaduanalesrm.com, trying worldtimeapi.org:", error);
    try {
      const date = await getDateWorldTimeApi(zona);
      return date;
    } catch (error) {
      console.error("Error fetching date from worldtimeapi.org, trying timeapi.io:", error);
      try {
        const date = await getDateTimeAPI(zona);
        return date;
      } catch (error) {
        console.error("Error fetching date from timeapi.io, trying worldclockapi.com:", error);
        try {
          const date = await getDateTimeAPI();
          return date;
        } catch (error) {
          console.error("Error fetching date from worldclockapi.com:", error);
          return new Date(); // Fallback a fecha local
        }
      }
    }
  }
}
